<template>
  <!--我参与的-->
  <div class="participate">
    <p class="text_uid" style="font-size:15px;margin:0;color:#999;padding-left:10px;">参与ID：<span  style="color:#b40000;line-height: 35px;">{{userId}}</span></p>
    <div id="ay-content"  v-infinite-scroll="loadMore" infinite-scroll-immediate-check="false"   immediate-check="false"  infinite-scroll-disabled="busy" infinite-scroll-distance="10" infinite-scroll-throttle-delay="1000">
      <div class="ay-content-list activity-list"  v-if="participate.length">
        <div class="ay-link ay-cor" v-for="(item,ind) in participate">
          <div :class="item.is_delete == 1?'':'ay-close'" :attr-id="item.form_id" :attr-type="item.file_type"></div>
          <p class="ay-title-time">{{item.create_time|datetime}}</p>
          <div class="ay-inr">
            <!-- <div class="ay-inr">-->
            <router-link tag="div" class="ay-pic-box"  :to="{name:'Detail',params: {id:item.activity_mini.id}}">
              <img class="ay-pic" v-if="item.activity_mini.playbill" :src="item.activity_mini.playbill.playbill_small_h5 + '?p=3&o=2&w=350&h=197'" alt=""/>
              <i class="ay-pic-t"></i>
            </router-link>
            <p class="ay-title" v-if="item.activity_mini">{{item.activity_mini.title}}</p>
            <p class="ay-time" v-if="item.activity_mini">{{item.activity_mini.end_time,item.activity_mini.start_time|orderBys}}</p>
          </div>
          <!-- </div>-->
          <div class="btn-ay btn-ay-box">
            <a href="javascript:void(0);" class="btn-ay-red" @click="modify(item.activity_mini.id,item.form_id,item.uploadimg,item.uploadvideo)"
               v-if="new Date(item.activity_mini.end_time)/1 >new Date(new Date()).getTime()">修改报名表</a>
            <a href="javascript:void(0);" class="btn-ay-end" v-else>修改报名表</a>
            <a href="javascript:void(0);" class="btn-ay-red btn-admin-work" @click="WorkManagement(item)" v-if="new Date(item.activity_mini.end_time)/1 >new Date(new Date()).getTime()">管理作品</a>
              <a href="javascript:void(0);" class="btn-ay-end" v-else>管理作品</a>
             <a href="javascript:void(0);" v-if="iswx" class="btn-ay-red btn-admin-work" @click="wxShare(item.activity_mini)">分享</a>
          </div>
        </div>
        <!-- load -->
        <div class="content index-content" v-show="!busy">
          <div class="id-content-inner">
            <div class="loader">
              <div class="loader-inner ball-pulse" style="display: block">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="foll_div" v-if="participate.length == 0">
        <div class="content index-content">
          <div class="id-content-inner">
            <div class="loader">
              <div class="loader-inner ball-pulse" style="display: block">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <!--<img class="loading-currency" style="width: 40px;height:40px;"  src="../../../static/dist/img/Loading.jpg" alt=""/>-->
      </div>
    </div>
    <div class="ay-content-modal">
      <div class="ay-modal-close">
        <span @click="end">返回</span>

        <p>{{titel}}</p>
      </div>
      <div class="ay-content-list ay-content-file">
        <div class="ay-link ay-cor" v-if="MyUpload.length > 0" v-for="(item,ind) in MyUpload">
          <div v-if="canEdit" :class="item.is_delete == 1?'':'ay-close ay-file'" :attr-id="item.uuid" :id="item.id"  :attr-type="item.file_type"></div>
          <p class="ay-title-time" v-if="item.file_type == 'video'" >{{item.file.upload_datetime|datetime}}</p>
          <p class="ay-title-time" v-if="item.file_type == 'image'">{{item.file.upload_time|datetime}}</p>
          <div class="ay-inr">

            <div class="ay-pic-box" @click="video(item)">
              <img v-if="item.file_type == 'video'" class="ay-pic" :src="item.file.thumb_url + '?p=3&o=2&w=350&h=197'" alt=""/>
              <img v-if="item.file_type == 'image'" class="ay-pic" :src="item.file.image_url + '?p=3&o=2&w=350&h=197'" alt=""/>
              <i class="ay-pic-t" v-if="item.file.time_span">{{item.file.time_span|formatSeconds}}</i>
            </div>
            <p class="ay-title">{{item.file.title}}</p>
            <div class="btn-ay">
              <a v-if="canEdit&& item.file.status == 'approved'" href="javascript:void(0);" class="btn-ay-red btn-ay-edit" @click="edit(item.id,item.file_type,item.file.title,item.file.description,item.file_id)">编辑</a>
            </div>

          </div>
          <div class="ay-inr-bottom" v-if="item.file">

            <span class="icon-ygs" v-if="item.file.status == 'approved'">
               <i style="font-style: normal" v-if="item.file.is_edit == '1'">审核中（编辑）</i>
               <i style="font-style: normal" v-else>审核通过</i>
            </span>
     
            <span class="icon-ygs" v-if="item.file.status == 'none' && item.file.audit_level === 0">
            <i style="font-style: normal">上传成功</i>
          </span>
          <span class="icon-ygs" v-if="item.file.status == 'none'  && item.file.audit_level !== 0">
            <i style="font-style: normal">审核中</i>
          </span>


         <!--   <span class="icon-ygs" v-if="item.file.status == 'approved'">
                审核通过
            </span>-->
            <span class="icon-ygs" v-if="item.file.status == 'rejected'">
                审核未通过
            </span>
            <span class="icon-poll">
                    {{item.file.vote_num|ticket}}
            </span>

            <span class="icon-btj" v-if="item.is_recommend == 1">
                    被推荐
            </span>
            <span class="icon-bxy" v-if="item.is_recommend == 1">
                    被选用
            </span>
           <!-- <span v-if="item.file_type == 'video'" style="font-size: 14px;color: #999">
              播放数:{{item.file.visit_num}}
            </span>
            <span  v-if="item.file_type == 'image'" style="font-size: 14px;color: #999">
              浏览数:{{item.file.visit_num}}
            </span>-->
          </div>
        </div>
        <!-- load -->
        <div class="content index-content" v-if="MyUpload.length == 0" style="text-align: center;color: #888">
          <div class="id-content-inner">
            <div class="loader">
              <div class="loader-inner ball-pulse" style="display: block">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sing-modal upload-modal large-info-modal modal fade" id="editModal" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <div class="group">
                  <label>名称</label>

                  <div class="pl-ipbox">
                    <input type="text" id="titleName" placeholder="请输入名称"/>
                  </div>
                </div>
                <div class="group">
                  <label>描述</label>

                  <div class="pl-ipbox">
                    <textarea rows="3" id="descriptionName" placeholder="请输入描述信息"></textarea>
                  </div>
                </div>
                <div class="btn-modal-tw">
                  <a href="javascript:void(0);" class="btn-pl-start" @click="editcComplete">完成</a>
                  <a href="javascript:void(0);" class="btn-pl-start" data-dismiss="modal">取消</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--删除活动-->
    <div class="sing-modal upload-modal large-info-modal modal fade" id="editModalactive" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <h3 class="Prompt-p">你确定要删除参与的活动？  </h3>
                <div class="btn-modal-tw" style="padding-bottom: 0">
                  <a href="javascript:void(0);" class="btn-pl-start" @click="DelActive">完成</a>
                  <a href="javascript:void(0);" class="btn-pl-start" data-dismiss="modal">取消</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--删除-->
    <div class="sing-modal upload-modal large-info-modal modal fade" id="editModals" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <h3 id="file-h3"  class="Prompt-p">你确定要删除上传文件？  </h3>
                <div class="btn-modal-tw">
                  <a href="javascript:void(0);" class="btn-pl-start" @click="DelFile">完成</a>
                  <a href="javascript:void(0);" class="btn-pl-start" data-dismiss="modal">取消</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Message :id=id :form_id=form_id :countArr="countArr"></Message> -->
    <div class="picture-content" @click="pictureHide">
      <div class="picture-content-div">
        <img class="picture-img" src="../../../static/dist/img/d.png" alt=""/>
      </div>
      <div class="picture-ph">
        <h3 class="picture-h3">详情title</h3>
        <p  class="picture-p">详情title详情title详情title</p>
      </div>
    </div>
    <Filedetails :fileItem="fileItem" :data="data" :tops = "tops"></Filedetails>
     <!--分享-->
    <div class="shart" @click="shareHide">
      <img :src="globalUrl + 'static/dist/img/weixin.png'" alt="">
    </div>
  </div>

</template>

<script>
  // import message from './MyParticipate-message.vue'
  import Filedetails from '../template/filedetails.vue'
  export default {
    props: [
      'userId',
      'initUtil'
    ],
    data (){
    return {
      participate: [],
      MyUpload: [],
      titel: '',
      page: 1,
      pages: 0,
      pageChl: 1,
      pagesize: '10',
      FileByUserid: null,
      ByUserid: null,
      scrill: false,
      scrills: false,
      ind: '',
      inds: '',
      fileId: '',
      id: '',
      file_type: '',
      form_id: '',
      total: 0,
      busy: false,
      countArr: [],
      fileItem: '',
      tops: '',
      data: '',
      detailsTxte: '',
      globalUrl: API.GlobalUrl,
      canEdit: true,
    }
  },

  methods: {
    //操作按钮事件


    pictureHide(){
      $('.picture-content').hide();
    },
    //跳转播放页面
    video(item){
      var that = this;
      that.fileItem = item;
      if(item.file.status == 'approved' ||  item.file.is_edit == 0 && item.file.status != 'rejected'){
        if(item.file_type == 'video'){
          this.data = new Date();
          this.setShareInfo(item);
        }else if(item.file_type == 'image'){
          this.data = new Date();
        }
        $('.preview-file').addClass('preview-active');
        // $('.dl-video-title').show();
        this.tops = $(document).scrollTop();
      }
    },

    /**
     * 设置分享信息
     * @param {[type]} fileInfo [description]
     */
    setShareInfo: function(item) {
      var dataName = {
        title: item.file.title,
        // desc: this.removeTAG(item.file.description, 110),
        desc: this.removeTAG('我参与了【'+item.activity_mini.title+'】', 110),
        imgAddress: item.file.thumb_url,
        Retain: '',// 保留
        url: API.UrlName + 'videoName/' + item.activity_id +'/' + item.file_id +'/video'
      };

      this.weixinShare(dataName)
    },

    //修改报名表
    modify(id,form_id,uploadImg,uploadVideo){
      //console.log(id,form_id)
      // this.id=id;
      // this.form_id=form_id;
      this.$router.push({name: 'Revise', params: {id: id,form_id:form_id}});//继续参与
      // this.countArr.push(uploadImg,uploadVideo)
      // $('.entry-content').show();
      // $('body').css('overflow','hidden')
    },
    //删除参与活动
    DelActive(){
      var that = this
      var Active = {
        form_id : that.id,
        user_id: that.userId
      };
     // console.log(Active)
      this.$http.get(API.DelActivityForm, {params: Active})
        .then(function (res) {
      //  console.log(res);
        if(res.code == 0){
         $('.ay-close').eq(that.ind).parents('.ay-cor').remove();
          $('#editModalactive').modal('hide');
          window.location.reload();
        /*  if($('.activity-list').children('.ay-cor').length == 0){
            that.participate = []
          }*/
        }
      })
    },
    //删除上传文件
    DelFile(){
      //删除视频
      var that = this;
  /*    $('.ay-file').eq(that.ind).parents('.ay-link').remove();
      $('#editModals').modal('hide');*/
 /*     if(that.file_type == '1'){
        var edit = API.DelEteVideo
      }else{
        //删除图片
        var edit = API.DelEteImage
      }*/
      this.$http.get(API.DelActivityFile, {params: {id: that.ID}})
        .then(function (res) {
          if(res.code == 0){
            $('.ay-file').eq(that.ind).parents('.ay-link').remove();
            $('#editModals').modal('hide');
          }
      })

    },
    //作品管理
    WorkManagement(item){
     // console.log(ind,title)
     var ind = item.activity_mini.id,
         title =item.activity_mini.title;
      // edit
      if(item.edit_form &&item.edit_form.is_show == 0){
        this.canEdit = false;
      }
      $('.icon-back').addClass('pointerEve');
      var that = this;
      //活动id
      that.titel = title;
      that.inds = ind;
      $('.ay-content-modal').addClass('ay-modal-show');
      that.initUtil.stopBodyScroll(true);
      that.MyUpload = [];
      that.ByUserid = {
        activity_id: that.inds,
        page: 1,
        pagesize: that.pagesize
      };
      //console.log(that.ByUserid)
    },
    edit(ind, file_type,title,description,uuid){
      $('.btn-modal-tw').attr('data-id',uuid).attr('file_type',file_type);
      $('#editModal').modal('show');
      $('#titleName').val(title);
      $('#descriptionName').val(description);
      //selected
      $('#editModal').find('option').eq(--file_type).prop('selected','selected')
    },
    editcComplete(){  //编辑
      //title  description
      var that = this;
      if($('#titleName').val() == ''){
        $('#titleName').focus()
      }else if($('#descriptionName').val() ==''){
        $('#descriptionName').focus()
      }else{
        var ActivityFile = {
          title: $('#titleName').val(),
          description: $('#descriptionName').val(),
          fileId: $('.btn-modal-tw').attr('data-id')
        };
        //console.log($('.btn-modal-tw').attr('data-id'));
        var edit;
        //判断类型  是图片还是视频
        if($('.btn-modal-tw').attr('file_type') == 'video'){
          edit = API.UpdataVideoAudit;
        }else{
          edit = API.UpdataImageAudit;
        }
        //console.log(ActivityFile)
        $.ajax({
          'url': edit,
          'data': ActivityFile,
          'type': 'POST',
          'dataType': 'json',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          success: function(res){
           //console.log(res)
            if(res.code == '0'){
              $('#editModal').modal('hide');
              $('#Prompt').modal('show');
              that.MyUpload = [];
              that.ByUserid = {
                activity_id: that.inds,
                page: 1,
                pagesize: that.pagesize
              };
            }
          }
        })
      }
    },
    end(){
        $('.icon-back').removeClass('pointerEve');;
        //  关闭作品管理
        $('.ay-content-modal').removeClass('ay-modal-show');
        this.initUtil.stopBodyScroll(false);
        //重新获取数据
    },
    //参与活动
    loadMore(){
      this.busy = true;
      // 多次加载数据
        setTimeout(() => {
          this.pages ++;
          this.ajaxMore(true);
        }, 500)
    },
    ajaxMore(flag){
      var that = this;
      that.FileByUserid = {
        page: that.pages,
        pagesize: that.pagesize
      };
    this.$http.get(API.GetActivitieByUserid, {params: that.FileByUserid})
      .then(function (res) {
       // console.log(res)
        if (res.code == 0) {
          if(flag){
            for (var i = 0; i < res.data.length; i++) {
              that.participate.push(res.data[i]);
            }
            that.$nextTick(function(){
              if (res.data.length === 0 || that.participate.length === res.total) {
                that.busy = true
              } else {
                that.busy = false
              }
            })

          }
          if(res.data.total == '0'){
              $('.foll_div').html('您还没有参与活动！')
          }
          // console.log(res.data)
        }
      })
    },
     shareHide() {
      $('.shart').hide()
    },
    wxShare(item){
      var that = this;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (isWeixin) {
        $('.shart').show()
      }

      that.$http.get(API.GetActivitieById, {params: {id: item.id}})
        .then(function (res) {
            console.log(res)
            // return;
          if (res.code == 0) {

            var dataTime = new Date(res.data.end_time).getTime() / 1 - new Date().getTime();
            if (dataTime < 0) {
              that.$router.push({name: 'Detail', params: {id: that.id}});
            }
            var detailsTxte = res.data;
            // that.route = detailsTxte.playbill.playbill;

            //分享微信
            var title = '', desc = '',img = '';
            if (detailsTxte.share_config) {
              var activity = detailsTxte.share_config.activity;
              if (activity && activity.share_title) {
                title = activity.share_title
              } else if (detailsTxte.share_config.share_title) {
                title = detailsTxte.share_config.share_title;
              } else {
                title = detailsTxte.title;
              }
              if (activity && activity.share_contents) {
                desc = activity.share_contents
              } else if (detailsTxte.share_config.share_contents) {
                desc = detailsTxte.share_config.share_contents
              } else {
                desc = detailsTxte.description
              }
              if (activity.share_pic) {
                  img = activity.share_pic
               } 
            } else {
              title = detailsTxte.title;
              desc = detailsTxte.description
              img =  detailsTxte.playbill.playbill_h5
            }
            document.title = title;
            let metas = $('head').children('meta');
            metas[1].content = desc;
            if (img == '' && detailsTxte.playbill && detailsTxte.playbill.playbill_h5) {
              img = detailsTxte.playbill.playbill_h5
            }
            console.log(img);
            var dataName = {
              title: title,  //分享标题
              desc: /*'央视热门栏目面向广大网友征集原创作品啦！要上电视？那就来吧！一个舞台不一样的精彩。',*/metas[1].content,//分享简介(内容)
              imgAddress: img,//分享图片地址
              Retain: '',//保留
              url: API.UrlName + 'detail/' + detailsTxte.id//点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
            };
            console.log(dataName)
            that.weixinShare(dataName)
          }
        });
    }
  },
  computed: {
    iswx: function(){
      var ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('micromessenger') != -1;
    }
  },
  //message
  components: {
    // Message: message,
      Filedetails: Filedetails
  },
  beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = true;
    next();
  },
  created:function () {
    //console.log(this.userId)
    //ajax数据请求
    var id = this.$route.params.id;
    var that = this;
    //暂时固定
   // if(id && id > 0){
   //   that.id = id;
   //   this.$http.get(API.GetMyActiviteInfo, {params: {activity_id: that.id}})
   //     .then(function (res) {
   //       if(res.code == 0){
   //         setTimeout(function(){
   //           that.form_id = res.data[0].form_id;
   //          //  that.countArr = '[0,0]';
   //           $('.entry-content').show();
   //         },1300)
   //       }
   //     });
   //   // 判断安卓机去掉动画
   //    that.isAndroid();
   //    //分享微信
   //    that.$http.get(API.GetActivitieById, {params: {id: that.id}})
   //      .then(function (res) {
   //        //   console.log(res)
   //        if (res.code == 0) {
   //          if (!res.data || res.data.length == 0) {
   //            that.$router.push({name: 'HomeIndex'})
   //          }
   //          var dataTime = new Date(res.data.end_time).getTime() / 1  - new Date().getTime();
   //          if (dataTime < 0) {
   //            that.$router.push({name: 'Detail', params: {id: that.id}});
   //          }
   //          var  detailsTxte = res.data;
   //          // that.route = detailsTxte.playbill.playbill;

   //          //分享微信
   //          var title = '', desc = '';
   //          if (detailsTxte.share_config) {
   //            var activity = detailsTxte.share_config.activity;
   //            if (activity && activity.share_title) {
   //              title = activity.share_title
   //            } else if (detailsTxte.share_config.share_title) {
   //              title = detailsTxte.share_config.share_title;
   //            } else {
   //              title = detailsTxte.title;
   //            }
   //            if (activity && activity.share_contents) {
   //              desc = activity.share_contents
   //            } else if (detailsTxte.share_config.share_contents) {
   //              desc = detailsTxte.share_config.share_contents
   //            } else {
   //              desc = detailsTxte.description
   //            }
   //          } else {
   //            title = detailsTxte.title;
   //            desc = detailsTxte.description
   //          }
   //          document.title = title;
   //          let metas = $('head').children('meta');
   //          metas[1].content = desc;
   //          var img = '';
   //          if (res.data.share_pic) {
   //            img = res.data.share_pic
   //          } else if (detailsTxte.playbill && detailsTxte.playbill.playbill_h5) {
   //            img = detailsTxte.playbill.playbill_h5
   //          }
   //          var dataName = {
   //            title: title,  //分享标题
   //            desc: that.removeTAG(desc, 110),//metas[1].content,//分享简介(内容)
   //            imgAddress: img,//分享图片地址
   //            Retain: '',//保留
   //            url: API.UrlName + 'detail/' + that.id//点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
   //          };
   //          that.weixinShare(dataName)
   //        }
   //      });
   // }
    //活动上传文件
    that.loadMore();
    $('.icon-back').removeClass('pointerEve');
    that.$watch('ByUserid', function () {
      //console.log(that.ByUserid)
        this.$http.get(API.GetActivityFileByUserid, {params: that.ByUserid})
          .then(function (res) {
        //console.log(res);
        if (res.code == 0) {
          that.total = res.total;
          for (var i = 0; i < res.data.length; i++) {
            // if(res.data[i].status ==="none"){
            //     if(res.data[i].file_type==='video'){
            //         res.data[i].file.thumb_url =API.GlobalUrl + 'static/dist/img/audit_1.jpg';
            //     }
            //     else {
            //         res.data[i].file.image_url=API.GlobalUrl + 'static/dist/img/audit_1.jpg';
            //     }
                
            // }
            // if(res.data[i].status ==="rejected"){
            //    if(res.data[i].file_type==='video'){
            //         res.data[i].file.thumb_url =API.GlobalUrl + 'static/dist/img/reject_1.jpg.png';
            //     }
            //     else {
            //         res.data[i].file.image_url=API.GlobalUrl + 'static/dist/img/reject_1.jpg';
            //     }
            // }

            that.MyUpload.push(res.data[i]);
           // console.log(i)
          }
          if(res.total == 0){
            $('.ay-content-file .index-content').html('未查找到报名数据！')
          }
        }
      });
     //console.log(that.MyUpload.length)
    })


  }
  ,
  mounted: function () {
    //操作DOM
    var that = this;
    var len = this.pagesize,
      lens = this.pagesize;

    //活动滚动事件，加载数据
    $(window).scroll(function () {
      if ($(window).scrollTop() > 1000) {
        $('.back-top').show();
      } else {
        $('.back-top').hide();
      }
    });
      $('.nav').children('.id-nav-recom').eq(0).addClass('nav-on').siblings().removeClass('nav-on')
      $('.nav').find('.id-nav-recom').eq(0).addClass('router-link-exact-active').siblings().removeClass('router-link-exact-active')


    //活动上传文件
    $('.ay-content-modal').scroll(function () {
      if (that.MyUpload.length >= lens || that.MyUpload.length < that.total) {
        that.scrills = true;
      }
     var H = $('.ay-content-file').outerHeight()- document.body.clientHeight;
      //滚动加载数据
      if ($('.ay-content-modal').scrollTop() > H && that.scrills) {
        that.scrills = false;
        lens = lens / 1 + 10;
        var pageChl = ++that.pageChl;
        //参与活动
        that.ByUserid = {
          activity_id: that.inds,
          page: pageChl,
          pagesize: that.pagesize
        };
      }
    });


    //删除参与的
    $('#ay-content').on('click','.ay-close',function () {
      that.id = $(this).attr('attr-id');
      that.ind = $(this).parents().index();
      //console.log(that.id,that.ind);
      $('#editModalactive').modal('show');
    });
    //删除上传文件
    //   $('#editModals').modal('show');
    $('.participate').on('click','.ay-file',function(){

      that.fileId = $(this).attr('attr-id');
      that.ID = $(this).attr('id');
      that.ind = $(this).parents().index();
      that.file_type =  $(this).attr('attr-type');
     //console.log(that.fileId,that.ID);
      $('#editModals').modal('show');
    });
    this.initUtil.stopBodyScroll(false);

    //微信分享

    let metas = $('head').children('meta');
  }

  }
</script>

<style>
.myActivity{
  position: relative;
}
.picture-content{
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,1);
  z-index: 99;
}
.picture-content-div{
  width: 90%;
  height: 100%;
  margin: 0 auto;
}
.picture-content img{
  width: 100% ;
  height: auto;
  max-height: 80%;
  margin-bottom: 10px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.picture-ph h3{
  position: fixed;
  font-size: 15px;
  margin-bottom: 10px;
  top: 10px;
  width: 90%;
  left: 5%;
  color: #fff;
}
.picture-ph p {
  position: fixed;
  bottom: 10px;
  width: 90%;
  left: 5%;
  color: #fff;
  font-size: 13px;
  line-height: 20px;
}
.ay-content .ay-link .btn-ay-box {
  display: flex;
  justify-content: space-around;
}

.ay-content .ay-link .btn-ay .btn-ay-end,
.ay-content .ay-link .btn-ay .btn-ay-red{
  font-size: 13px;
}
@media screen and (max-width: 320px){
  .ay-content .ay-link .btn-ay .btn-ay-end,
  .ay-content .ay-link .btn-ay .btn-ay-red {
    font-size: 12px;
    width: 80px;
  }
}
.shart {
    position: fixed;
    display: none;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
  }

  .shart img {
    width: 65%;
    float: right;
    height: auto;
  }
</style>




// WEBPACK FOOTER //
// src/components/myActivity/participate.vue